import { type FunctionalComponent } from "vue";
import { tv } from "tailwind-variants";
import type { IconLabelProps } from "./type";

const iconLabelClazz = tv({
	slots: {
		base: "flex flex-row items-center gap-1.5 min-w-0",
		icon: "flex items-center justify-center w-3 h-3 text-gray-400",
		text: "text-gray-500 text-xs font-medium",
	},
	variants: {
		border: {
			true: {
				base: "border bg-gray-100 border-gray-300 rounded-sm px-3 py-2 min-w-0",
			},
		},
	},
});

export const IconLabel: FunctionalComponent<IconLabelProps> = (props) => {
	const classes = iconLabelClazz({ border: props.border });

	return (
		<div class={classes.base()}>
			<div class={classes.icon() + ' ' + (props.iconClass ?? '')}>
				<props.icon class="w-3 h-3" />
			</div>
			<div class={classes.text() + ' ' + (props.textClass ?? '')}>{props.text}</div>
		</div>
	);
};